// extracted by mini-css-extract-plugin
module.exports = {"iconListItem":"_2tpjAz","iconListIcon":"_1Aj4is","socialContainer":"_29tXOi","social":"_1mwl6y"};